import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "01f27143-c4ab-4442-af51-84e3a5183950", content: "Unidirectional", options: {} },
  { id: "6e26f6aa-3826-4519-a849-c9789a203404", content: "Hypocardioid", options: {} },
  { id: "797f9c25-4eb1-49c7-ab70-5c42d6f65462", content: "Cardioid", options: {} },
  { id: "f3bb2e06-b530-4505-8b98-315db4e14da8", content: "Supercardioid", options: {} },
  { id: "b42369d7-bac0-4021-a209-b83ff88fadb9", content: "Hypercardioid", options: {} },
  { id: "1c080a55-4def-40b7-bd1f-8d03bdf02b82", content: "Bidirectional", options: {} },
];

export const task: Task = {
  id: "759465f8-8773-4b0f-a8f9-9264a815535f",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["1c080a55-4def-40b7-bd1f-8d03bdf02b82"],
};
